import React, { useState, useEffect } from 'react';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';

const TIMER_COLORS = ['#12B8A0', '#FFC42E', '#FF7A1A', '#FF5470'];

const RevealedLetters = ({ letters, selectedLetters, onLetterSelect, currentDelay, onDelayFinished, onRevealLetter,
    currentTurnPlayer, thisPlayer, letterPoolCount, currentTurn, players, settings }) => {

    const isSolo = !!(settings.solo && settings.solo.isSolo);
    const letterLimit = isSolo ? settings.solo.windowSize : 1000;
    const fadedLimit = 3;
    const [prevLetters, setPrevLetters] = useState([]);

    useEffect(() => {
        const timer = setTimeout(() => setPrevLetters(letters), 700);
        return () => clearTimeout(timer);
    }, [letters]);

    const isNewLetter = (index) => index === 0 && prevLetters.length < letters.length;

    const showRevealButton = () =>
        isSolo || (!(currentDelay > 0) && players.length > 1);

    const getUniqueKey = (letter, index) =>
        isNewLetter(index) ? `${letter}-${new Date().getTime()}-${index}` : `${letter}-${index}`;

    const isMyTurn = currentTurnPlayer && thisPlayer && currentTurnPlayer.id === thisPlayer.id;
    const visibleLetters = letters.slice(0, letterLimit + fadedLimit);
    const lowPool = letterPoolCount <= 5;

    return (
        <div className="sg-stack" style={{ gap: '14px', alignItems: 'center' }}>
            {currentDelay > 0 && (
                <div style={{ display: 'flex', justifyContent: 'center', padding: '6px' }}>
                    <CountdownCircleTimer
                        isPlaying={currentDelay > 0}
                        duration={currentDelay}
                        size={58}
                        strokeWidth={6}
                        trailColor="#F6E2C2"
                        colors={TIMER_COLORS}
                        colorsTime={[7, 5, 2, 0]}
                        onComplete={() => onDelayFinished()}
                    >
                        {({ remainingTime }) => (
                            <span style={{ fontWeight: 900, fontSize: '1.3rem', color: 'var(--ink)' }}>{remainingTime}</span>
                        )}
                    </CountdownCircleTimer>
                </div>
            )}

            {showRevealButton() && (
                <>
                    {currentTurnPlayer && currentTurn > -2 && (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            {isMyTurn ? (
                                <button
                                    className="sg-btn sg-btn--primary"
                                    onClick={onRevealLetter}
                                    disabled={currentTurn === -2}
                                >
                                    {letters.length === 0 ? '✨ Reveal a letter' : '➕ New letter'}
                                </button>
                            ) : (
                                <span className="sg-badge">
                                    <span style={{ width: 8, height: 8, borderRadius: 99, background: 'var(--tangerine)', display: 'inline-block' }} />
                                    {currentTurnPlayer.name}'s turn
                                </span>
                            )}
                        </div>
                    )}

                    {visibleLetters.length > 0 && (
                        <div className="sg-shelf" style={{ width: '100%', maxWidth: '460px' }}>
                            <div className="sg-wrap" style={{ gap: '8px', justifyContent: 'center' }}>
                                {visibleLetters.map((letter, index) => {
                                    const selected = selectedLetters.some(l => l.letter === letter && l.index === index);
                                    const faded = index >= letterLimit;
                                    const disabled = currentDelay > 0 || currentTurn === -2 || faded;
                                    return (
                                        <button
                                            key={getUniqueKey(letter, index)}
                                            onClick={() => onLetterSelect(letter, index)}
                                            disabled={disabled}
                                            className={[
                                                'sg-tile', 'sg-tile--md', 'sg-tile--btn',
                                                selected ? 'sg-tile--selected' : '',
                                                faded ? 'sg-tile--disabled' : '',
                                                isNewLetter(index) ? 'sg-anim-drop' : '',
                                            ].join(' ')}
                                        >
                                            {letter}
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    {currentTurn > -2 && letters.length > 0 && (
                        <span className={`sg-badge${lowPool ? ' sg-badge--low' : ''}`} style={lowPool ? { background: 'var(--bubblegum)', color: '#fff' } : undefined}>
                            {letterPoolCount} {letterPoolCount === 1 ? 'letter' : 'letters'} left in the bag
                        </span>
                    )}
                </>
            )}
        </div>
    );
};

export default RevealedLetters;
